module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "ownermanual"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "layout_fullwidth_padding"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRequestActive),
      expression: "isRequestActive"
    }],
    staticClass: "loader"
  }, [_c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15,
      "color": "#f9f300"
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Owner's Manual")]), _vm._v(" "), _c('h5', [_vm._v("Vehicle Make")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerModel.make),
      expression: "ownerModel.make"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ownerModel, "make", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.setMakes()
      }]
    }
  }, _vm._l((_vm.makes), function(make) {
    return _c('option', {
      key: make,
      domProps: {
        "value": make
      }
    }, [_vm._v(_vm._s(make))])
  }), 0), _vm._v(" "), _c('h5', [_vm._v("Vehicle Model")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerModel.model),
      expression: "ownerModel.model"
    }],
    attrs: {
      "disabled": _vm.models.length == 0 ? true : false
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ownerModel, "model", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.setModels()
      }]
    }
  }, _vm._l((_vm.models), function(curModel) {
    return _c('option', {
      key: curModel,
      domProps: {
        "value": curModel
      }
    }, [_vm._v(_vm._s(curModel))])
  }), 0), _vm._v(" "), _c('h5', [_vm._v("Vehicle Year")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ownerModel.year),
      expression: "ownerModel.year"
    }],
    attrs: {
      "disabled": _vm.years.length == 0 ? true : false
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ownerModel, "year", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.setYears()
      }]
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('option', {
      key: year,
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  }), 0), _vm._v(" "), _vm._l((_vm.owners), function(owner) {
    return _c('a', {
      key: owner.id,
      staticClass: "button_full btyellow external",
      style: (_vm.borderStyle),
      attrs: {
        "target": "_blank",
        "href": owner.fileUrl
      },
      on: {
        "click": function($event) {
          return _vm.openBrochure(owner)
        }
      }
    }, [_vm._v("\n            Download " + _vm._s(owner.year) + " " + _vm._s(owner.make) + " " + _vm._s(owner.model) + " " + _vm._s(owner.submodel) + " Manual")])
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("Owner's Manual Saved history")]), _vm._v(" "), _c('ul', {
    staticClass: "responsive_table"
  }, [_c('li', {
    staticClass: "table_row",
    style: (_vm.borderStyle)
  }, [_c('div', {
    staticClass: "table_section table_section_brochure"
  }, [_vm._v("Manual")]), _vm._v(" "), _c('div', {
    staticClass: "table_section"
  }, [_vm._v("Date")])]), _vm._v(" "), _vm._l((_vm.ownerHistory), function(ownerH) {
    return _c('li', {
      key: ownerH.openDate,
      staticClass: "table_row"
    }, [_c('div', {
      staticClass: "table_section table_section_brochure"
    }, [_c('a', {
      staticClass: "external",
      attrs: {
        "href": ownerH.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.openBrochure(ownerH)
        }
      }
    }, [_vm._v(_vm._s(ownerH.year) + " " + _vm._s(ownerH.make) + " " + _vm._s(ownerH.model) + " " + _vm._s(ownerH.submodel))])]), _vm._v(" "), _c('div', {
      staticClass: "table_section"
    }, [_vm._v(_vm._s((ownerH.openDate != null ? new Date(ownerH.openDate).toLocaleDateString() : "New brochure")))])])
  })], 2)], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-449fbb4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-449fbb4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/ownermanual.vue
// module id = 821
// module chunks = 0